import type { FaireProductEntity } from "../../entity_types/product";

export const p_2qtb6fjnen: FaireProductEntity = {
  token: "p_2qtb6fjnen",
  type: "product",
  name: "Milky Santal– HI-FI Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/c6e641b8d4b836e75a3b499d32305b38b33bf2ad983ff5b2b6868b6c58ee7c1d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4f095300a07564b18db66091899ef4525471eeb4323149949c22f102e9f7d10f.jpeg",
    "https://cdn.faire.com/fastly/0d3ccd1c24bc9bb90a4b457533a914a41dfd8a239773afb93ad429e3ae49bde6.jpeg",
    "https://cdn.faire.com/fastly/1bf2d3826b3d2c1352108216fa7b9940ae25b652cf4145e1b78ce76724d60c33.jpeg",
    "https://cdn.faire.com/fastly/56581e0a3cff8ab7cdb8fa29065a6d7cb0e7a7f1e17d2bea7f273c75ba54023a.jpeg",
  ],
  priceDollars: 19.5,
  description:
    '*Due to unexpected supply chain shifts, we are experiencing a gap in our production schedule. Sold out HI-FI products are expected to restock this Summer*\n\nA creamy, grounding gourmand. Rice milk vapor, warm plush robes, grounding sandalwood.\n\nMilky Santal is an elevated, lactonic take on a gourmand. Comforting, soft, and quietly luxurious, like a warmed plush robe and rice milk-infused baths. Skin-like musks and nuanced woods bring a velvet complexity, instantly upping the coziness.\n\nTop notes of rice milk vapor, oats, and patchouli leaf are blended with santal, warm cashmere, and white jasmine, then slightly sweetened by creamy tonka bean, musk, ambrette seed, and woody amyris, creating a nuanced gourmand.\n\nPRODUCT INFORMATION:\n\nEach diffuser contains a 4 fl oz blend of naturally-derived and man-made fragrance oils in a square custom cocoa brown glass bottle with a Vermilion debossed front label and packaged in a premium paper gift box.\n\nLasts approximately 3-4 months.\n\nIncludes a bundle of 9" long naturally-harvested black dyed rattan reeds to absorb and slowly release the fragrance.',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:55.573Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
